import megawati from './President_Megawati_Sukarnoputri_-_Indonesia_compressed.jpg';
import gloria from './Gloria-Macapagal-Arroyo_cropped.jpg';
import maria from './Corazon_Aquino_1986_compressed.jpg';
import chandrika from './dsc_2771_compressed.jpg';
import julia from './Julia_Gillard_2010.jpg';

import cover from './cover.jpg';

export default {megawati, gloria, maria, chandrika, julia, cover};
